import { Controller } from "@hotwired/stimulus"

// Rendered (inside the polled/broadcast status frame) once the LLM auto-fill has completed on the
// express "You've already started" interstitial. On connect it fires a window-level autofill:complete
// event carrying the final entry count, minutes saved, and the fully-filled section cards HTML — the
// page's autofill-reveal controller animates them in. Kept as a tiny separate controller so the reveal
// runs whether completion arrives via the client poll or the server broadcast.
export default class extends Controller {
  static targets = ["cards"]
  static values = { count: Number, minutes: Number, countWord: String, minuteWord: String }

  connect() {
    this.dispatch("complete", {
      target: window,
      prefix: "autofill",
      detail: {
        count: this.countValue,
        minutes: this.minutesValue,
        countWord: this.countWordValue,
        minuteWord: this.minuteWordValue,
        cardsHtml: this.hasCardsTarget ? this.cardsTarget.innerHTML : ""
      }
    })
  }
}
